import React from 'react';
import { Search } from 'lucide-react';

const SearchFilter = ({ searchTerm, onSearchChange }) => {
    return (
        <div className="relative mb-4">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            <input
                type="text"
                placeholder="Search work items..."
                value={searchTerm}
                onChange={(e) => onSearchChange(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
            />
        </div>
    );
};

export default SearchFilter;